module.exports = __webpack_public_path__ + "static/media/launcher.8749e919.png";